import { useCallback } from 'react';
import { retainTaskCampaignFilters } from '../../../../../models/Task/campaignFilters';
import { IncomingCallsRequest } from '../../../../../store/reducers/IncomingCallsSlice';
import { ReportRequest } from '../../../../../store/reducers/ReportSlice';

interface Props {
  onCallRequest: (value: IncomingCallsRequest) => void;
  callRequest: IncomingCallsRequest;
  onCallRequestReport: (value: ReportRequest) => void;
  callRequestReport: ReportRequest;
}

export const useIncomingFilterChanges = ({
  onCallRequest,
  callRequest,
  onCallRequestReport,
  callRequestReport,
}: Props) => {
  const handleClinics = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.ClinicIds': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        ClinicIds: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleCallStatus = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.States': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        States: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleAttemptStatus = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.AttemptStates': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        AttemptStates: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleCallResult = useCallback(
    (e: string[]) => {
      onCallRequest({
        ...callRequest,
        'Filter.Results': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        Results: e,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  const handleScenario = useCallback(
    (e: string[]) => {
      const campaigns = retainTaskCampaignFilters(e, {
        FormTemplateIds: callRequest['Filter.FormTemplateIds'],
        FormBatchIds: callRequest['Filter.FormBatchIds'],
        DispensarizationBatchIds:
          callRequest['Filter.DispensarizationBatchIds'],
      });
      onCallRequest({
        ...callRequest,
        PageIndex: 0,
        'Filter.FormTemplateIds': campaigns.FormTemplateIds,
        'Filter.FormBatchIds': campaigns.FormBatchIds,
        'Filter.DispensarizationBatchIds': campaigns.DispensarizationBatchIds,
        'Filter.Types': e,
      });

      onCallRequestReport({
        ...callRequestReport,
        Types: e,
        ...campaigns,
      });
    },
    [onCallRequest, callRequest, onCallRequestReport, callRequestReport],
  );

  return {
    handleClinics,
    handleCallStatus,
    handleAttemptStatus,
    handleCallResult,
    handleScenario,
  };
};
